import type { ReactNode } from 'react';
import s from './NavigationHeader.module.css';
import { type LanguageCore, Text } from '../Language/Language';
import { Flex } from '@repo/ui/Flex';
import { useIsMobile } from '@repo/lib/hooks/useMediaQuery';
import { clsx } from 'clsx';
import { IconButton } from '@repo/ui/IconButton';

export const NavigationHeader = ({
  title,
  onClose,
  onBack,
  leftChildren,
}: {
  title: LanguageCore;
  onClose?: () => void;
  onBack?: () => void;
  leftChildren?: ReactNode;
}) => {
  const isMobile = useIsMobile();
  return (
    <Flex
      as="header"
      alignItems="center"
      className={s.header}
      justifyContent="center"
      padding={['px-12', 'md:px-16']} // These are less than the mocks to offset the icon button touch target padding
    >
      <div className={s.container}>
        <Flex
          className={clsx([s.actionContainer, s.leftNav])}
          alignItems="center"
          justifyContent="center"
        >
          {onBack && (
            <IconButton
              className={s.backButton}
              icon="chevron"
              label={<Text langKey="Global.back" />}
              onClick={onBack}
            />
          )}
          {leftChildren}
        </Flex>
        <div
          className={clsx({
            [s.title]: true,
            [s.mobile]: isMobile,
          })}
        >
          <Text {...title} />
        </div>
        <Flex
          className={clsx([s.actionContainer, s.rightNav])}
          alignItems="center"
          justifyContent="center"
        >
          {onClose && (
            <IconButton
              icon="close"
              label={<Text langKey="Global.close" />}
              onClick={onClose}
            />
          )}
        </Flex>
      </div>
    </Flex>
  );
};
